import * as React from 'react';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { getEmailLists, toggleEmailSubscription } from '@/redux/modules/emailList';
import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

const UnsubscribeEmail = () => {
    const dispatch = useAppDispatch();
    const { formatMessage } = useIntl();
    const emailList = useAppSelector(getEmailLists);
    const { search } = useLocation();
    const navigate = useNavigate();
    const userEmail = useAppSelector(getBidderEmail);
    const queryParams = queryString.parse(search);
    const { unsubscribe: unsubscribeParam = '' } = queryParams;

    React.useEffect(() => {
        if (!unsubscribeParam || !userEmail || !emailList.length) {
            return;
        }
        const emailSelection: any = emailList.find(({ code }) => code === unsubscribeParam);

        if (unsubscribeParam === 'Unsubscribed All') {
            // handle the case that they want to unsubscribe to everything

            dispatch(toggleEmailSubscription(unsubscribeParam));
            toast('success', {
                description: formatMessage(
                    {
                        id: 'toastMessages.descriptions.unsubscribeAllEmailPreference',
                    },
                    { email: `${userEmail}` }
                ),
                title: formatMessage({
                    id: 'toastMessages.titles.success',
                }),
            });
        } else if (emailSelection?.subscribed) {
            // @ts-ignore
            dispatch(toggleEmailSubscription(unsubscribeParam));
            toast('success', {
                description: formatMessage(
                    {
                        id: 'toastMessages.descriptions.unsubscribeEmailPreference',
                    },
                    {
                        alert: `${emailSelection.name}`,
                        email: `${userEmail}`,
                    }
                ),
                title: formatMessage({
                    id: 'toastMessages.titles.success',
                }),
            });
        } else if (!emailSelection?.name) {
            // handle unrecognized subscriptions codes
            toast('error', {
                description: formatMessage({
                    id: 'toastMessages.descriptions.unsubscribeEmailDontRecognize',
                }),
                title: formatMessage({
                    id: 'toastMessages.titles.success',
                }),
            });
        }

        navigate({});
    }, [dispatch, emailList, userEmail, unsubscribeParam, navigate, formatMessage]);

    return null;
};

export default UnsubscribeEmail;
